const blockFragment = `
  id
  typeHandle
  idName
  theme
  imageAlignInline
  image {
    url
    title
    hasFocalPoint
    focalPoint
  }
  video {
    url
    title
  }
  heading
  copy
  button {
    type
    url
    text
    target
  }
`

export const CImageCopyBlocksFragments = {
  field: `
    fragment imageCopyBlocks on imageCopyBlocks_MatrixField {
      ... on imageCopyBlocks_block_Entry {
        ${blockFragment}
      }
    }
  `,
  field2: `
    fragment imageCopyBlocks2 on imageCopyBlocks2_MatrixField {
      ... on imageCopyBlocks2_block_Entry {
        ${blockFragment}
      }
    }
  `,
  field3: `
    fragment imageCopyBlocks3 on imageCopyBlocks3_MatrixField {
      ... on imageCopyBlocks3_block_Entry {
        ${blockFragment}
      }
    }
  `,
  uiField: `
    fragment uiImageCopyBlocks on uiImageCopyBlocks_MatrixField {
      ... on uiImageCopyBlocks_block_Entry {
        ${blockFragment}
      }
    }
  `,
  uiField2: `
    fragment uiImageCopyBlocks2 on uiImageCopyBlocks2_MatrixField {
      ... on uiImageCopyBlocks2_block_Entry {
        ${blockFragment}
      }
    }
  `,
}
